import { batches } from "@api/stores/products/batches/path";
import { bulkCreate } from "@api/stores/products/bulk/path";
import { prices } from "@api/stores/products/prices/path";
import { stats } from "@api/stores/products/stats/path";
import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/products/`;
const pathById = `${pathBase}:productId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const products = {
  get: apiPathFunc(pathById),
  getAll: apiPathFunc(pathBase),
  post: apiPathFunc(pathBase),
  patch: apiPathFunc(pathById),
  stats,
  bulkCreate,
  batches,
  prices,
};
